export default "__VITE_ASSET__BOvbI7tG__"